import { AppTranslationPipe } from '@adapter/i18n/app-translation.pipe';
import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Componente para mostrar un mensaje de acceso denegado
 * cuando un usuario no tiene permiso para ver una página
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-access-denied',
  imports: [AppTranslationPipe],
  template: `
    <div class="bg-gray-100 flex items-center justify-center h-screen">
      <div class="bg-white p-8 rounded-lg shadow-lg text-center">
        <h1 class="text-4xl font-bold text-red-600 mb-4">
          {{ 'security.access-denied' | translate }}
        </h1>
        <p class="text-gray-700 mb-6">
          {{ 'security.access-denied-message' | translate }}
        </p>
        <a href="/" class="text-blue-500 hover:underline">{{
          'security.back-option-message' | translate
        }}</a>
      </div>
    </div>
  `,
  styles: ``
})
export class AccessDeniedComponent {}
